(() => {
  const app = window.Digitaliz;
  if (!app) return;
  window.DigitalizModules = window.DigitalizModules || {};
  if (window.DigitalizModules.cart) return;
  window.DigitalizModules.cart = true;

  // Minimum-quantity rule: non-exempt cart lines cannot drop below this floor.
  // Lines carrying the _min_qty_exempt property (e.g. future frequently-bought-
  // together add-ons) are never floored. Mirrors the value set in theme.liquid.
  const MIN_QTY = (window.themeSettings && Number(window.themeSettings.minQty)) || 2;
  const minQtyNoteTimers = new Map();

  // Reveals the "minimum N per item" note for a line, then auto-hides it.
  function showMinQtyNote(key) {
    const notes = document.querySelectorAll(`[data-min-qty-note="${key}"]`);
    notes.forEach((note) => note.classList.add("is-visible"));
    clearTimeout(minQtyNoteTimers.get(key));
    minQtyNoteTimers.set(
      key,
      setTimeout(() => {
        document
          .querySelectorAll(`[data-min-qty-note="${key}"]`)
          .forEach((note) => note.classList.remove("is-visible"));
        minQtyNoteTimers.delete(key);
      }, 4000)
    );
  }

  async function getCart() {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Cart fetch failed");
    return response.json();
  }

  function removeIcon() {
    return `<svg xmlns="http://www.w3.org/2000/svg" class="icon-remove" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/></svg>`;
  }

  function createCartItemElement(item) {
    const li = document.createElement("li");
    li.className = "cart-item-wrap";
    li.setAttribute("data-cart-drawer-line-key", item.key);

    // Right side — image
    const rightSide = document.createElement("div");
    rightSide.className = "right-side";

    if (item.featured_image?.url) {
      const media = document.createElement("div");
      media.className = "cart-item__media";

      const link = document.createElement("a");
      link.href = item.url || "#";
      link.className = "cart-item__link";
      link.tabIndex = -1;
      link.setAttribute("aria-hidden", "true");
      link.textContent = " ";
      media.appendChild(link);

      const img = document.createElement("img");
      const src = item.featured_image.url;
      img.src = src.includes("?") ? src : `${src}?width=300`;
      img.alt = item.featured_image.alt || item.product_title;
      img.className = "cart-item__image";
      img.loading = "lazy";
      media.appendChild(img);

      rightSide.appendChild(media);
    }

    li.appendChild(rightSide);

    // Left side — content
    const leftSide = document.createElement("div");
    leftSide.className = "left-side";

    // Top part — title + options
    const topPart = document.createElement("div");
    topPart.className = "top-part";

    const details = document.createElement("div");
    details.className = "cart-item__details";

    const nameLink = document.createElement("a");
    nameLink.href = item.url || "#";
    nameLink.className = "cart-item__name";
    nameLink.textContent = item.product_title;
    details.appendChild(nameLink);
    topPart.appendChild(details);

    // Variant options (from options_with_values, or fall back to variant_title)
    const hasOptions = Array.isArray(item.options_with_values) && item.options_with_values.length > 0;
    const isDefaultVariant = !item.variant_title || item.variant_title === "Default Title";

    if (hasOptions && !isDefaultVariant) {
      const dl = document.createElement("dl");
      item.options_with_values.forEach(({ name, value }) => {
        const optDiv = document.createElement("div");
        optDiv.className = "product-option";
        const dt = document.createElement("dt");
        dt.textContent = `${name}:`;
        const dd = document.createElement("dd");
        dd.textContent = ` ${value}`;
        optDiv.appendChild(dt);
        optDiv.appendChild(dd);
        dl.appendChild(optDiv);
      });
      topPart.appendChild(dl);
    } else if (item.variant_title && !isDefaultVariant) {
      const dl = document.createElement("dl");
      const optDiv = document.createElement("div");
      optDiv.className = "product-option";
      const dt = document.createElement("dt");
      dt.textContent = `${item.variant_title}`;
      optDiv.appendChild(dt);
      dl.appendChild(optDiv);
      topPart.appendChild(dl);
    }

    // Line-item properties (skip private _keys, e.g. _min_qty_exempt)
    const visibleProps = Object.entries(item.properties || {}).filter(
      ([key, value]) => key && !key.startsWith("_") && value != null && `${value}`.trim() !== ""
    );
    if (visibleProps.length) {
      const dl = document.createElement("dl");
      visibleProps.forEach(([key, value]) => {
        const optDiv = document.createElement("div");
        optDiv.className = "product-option";
        const dt = document.createElement("dt");
        dt.textContent = `${key}:`;
        const dd = document.createElement("dd");
        dd.textContent = ` ${value}`;
        optDiv.appendChild(dt);
        optDiv.appendChild(dd);
        dl.appendChild(optDiv);
      });
      topPart.appendChild(dl);
    }

    // Selling plan
    if (item.selling_plan_allocation?.selling_plan?.name) {
      const dl = document.createElement("dl");
      const optDiv = document.createElement("div");
      optDiv.className = "product-option";
      const dt = document.createElement("dt");
      dt.textContent = item.selling_plan_allocation.selling_plan.name;
      optDiv.appendChild(dt);
      dl.appendChild(optDiv);
      topPart.appendChild(dl);
    }

    // Unit price
    if (item.unit_price_measurement) {
      const ref = item.unit_price_measurement.reference_value === 1 ? "" : item.unit_price_measurement.reference_value;
      const dl = document.createElement("dl");
      const optDiv = document.createElement("div");
      optDiv.className = "product-option";
      const dt = document.createElement("dt");
      app.setCurrency(dt, item.unit_price, { after: ` / ${ref}${item.unit_price_measurement.reference_unit}` });
      optDiv.appendChild(dt);
      dl.appendChild(optDiv);
      topPart.appendChild(dl);
    }

    leftSide.appendChild(topPart);

    // Bottom part — quantity stepper + line price
    const bottomPart = document.createElement("div");
    bottomPart.className = "bottom-part";

    const quantityWrapper = document.createElement("div");
    quantityWrapper.className = "cart-item__quantity";

    const exempt = Boolean(item.properties && item.properties._min_qty_exempt);

    const qtyControls = document.createElement("div");
    qtyControls.className = "cart-qty-controls";

    const minusBtn = document.createElement("button");
    minusBtn.type = "button";
    minusBtn.className = "cart-qty-btn";
    minusBtn.setAttribute("data-qty-action", "minus");
    minusBtn.setAttribute("data-cart-qty-key", item.key);
    minusBtn.setAttribute("aria-label", window.themeStrings.decrease || "Decrease quantity");
    minusBtn.textContent = "−";
    qtyControls.appendChild(minusBtn);

    const input = document.createElement("input");
    input.id = `DrawerQty-${item.key}`;
    input.type = "number";
    input.min = exempt ? "1" : String(MIN_QTY);
    input.value = String(item.quantity);
    input.className = "cart-qty-input";
    input.setAttribute("data-cart-line-key", item.key);
    input.dataset.minQtyExempt = exempt ? "true" : "false";
    input.setAttribute("aria-label", window.themeStrings.quantity || "Quantity");
    qtyControls.appendChild(input);

    const plusBtn = document.createElement("button");
    plusBtn.type = "button";
    plusBtn.className = "cart-qty-btn";
    plusBtn.setAttribute("data-qty-action", "plus");
    plusBtn.setAttribute("data-cart-qty-key", item.key);
    plusBtn.setAttribute("aria-label", window.themeStrings.increase || "Increase quantity");
    plusBtn.textContent = "+";
    qtyControls.appendChild(plusBtn);

    quantityWrapper.appendChild(qtyControls);

    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "cart-remove-btn";
    removeBtn.setAttribute("data-cart-remove-line", item.key);
    removeBtn.setAttribute("aria-label", window.themeStrings.remove || "Remove");
    // removeIcon() returns a static SVG string with no user data — safe to use here
    removeBtn.innerHTML = removeIcon();
    quantityWrapper.appendChild(removeBtn);

    bottomPart.appendChild(quantityWrapper);

    // The Amai app is mapped to the price span by its exact class (and the
    // totals div's) — keep both classes unchanged. The volume-discount "was" /
    // "now" / "save" elements around it are filled by app-amai-cart-prices.js.
    const totals = document.createElement("div");
    totals.className = "cart-item__totals";

    const was = document.createElement("s");
    was.className = "cart-price-was";
    was.setAttribute("data-volume-was", "line");
    totals.appendChild(was);

    const price = document.createElement("span");
    price.className = "cart-item__price";
    app.setCurrency(price, item.final_line_price);
    totals.appendChild(price);

    const now = document.createElement("span");
    now.className = "cart-item__price-now";
    now.setAttribute("data-volume-now", "line");
    app.setCurrency(now, item.final_line_price);
    totals.appendChild(now);

    const vatLabel = (window.themeStrings && window.themeStrings.vatEx) || "";
    if (vatLabel) {
      const vatNote = document.createElement("span");
      vatNote.className = "cart-vat-note";
      vatNote.textContent = vatLabel;
      totals.appendChild(vatNote);
    }

    const save = document.createElement("span");
    save.className = "cart-price-save";
    save.setAttribute("data-volume-save", "line");
    totals.appendChild(save);

    bottomPart.appendChild(totals);

    leftSide.appendChild(bottomPart);

    // Minimum-quantity note (non-exempt lines only)
    if (!exempt) {
      const minNote = document.createElement("div");
      minNote.className = "cart-min-qty-note";
      minNote.setAttribute("data-min-qty-note", item.key);
      minNote.setAttribute("aria-live", "polite");
      minNote.textContent = (window.themeStrings && window.themeStrings.minQtyNote) || "";
      leftSide.appendChild(minNote);
    }

    li.appendChild(leftSide);

    return li;
  }

  function renderCartDrawer(cart) {
    const root = document.querySelector("[data-cart-drawer-items]");
    const count = document.querySelectorAll("[data-cart-count]");
    // Skip the Amai app's copies of the subtotal (they carry our data attribute
    // too): they hold the app's discounted figures, which app-amai-cart-prices.js reads.
    const totals = document.querySelectorAll(
      "[data-cart-total]:not([data-integration-price-created]):not([data-integration-price-saved])"
    );

    count.forEach((node) => {
      node.textContent = cart.item_count;
    });

    totals.forEach((node) => {
      app.setCurrency(node, cart.total_price);
    });

    const statusNode = document.querySelector("[data-cart-status]");
    if (statusNode) {
      statusNode.textContent = cart.item_count === 0
        ? window.themeStrings.cartEmpty || "Your cart is empty."
        : `${cart.item_count} ${cart.item_count === 1 ? (window.themeStrings.item || "item") : (window.themeStrings.items || "items")}, ${app.currency(cart.total_price)}`;
    }

    const viewCartBtn = document.querySelector("[data-cart-view-cart-btn]");
    const checkoutBtn = document.querySelector("[data-cart-checkout-btn]");
    const isEmpty = cart.item_count === 0;
    if (viewCartBtn) {
      viewCartBtn.classList.toggle("disabled", isEmpty);
      viewCartBtn.setAttribute("aria-disabled", String(isEmpty));
    }
    if (checkoutBtn) {
      checkoutBtn.classList.toggle("disabled", isEmpty);
      checkoutBtn.disabled = isEmpty;
    }

    if (!root) return;

    root.replaceChildren();

    if (!cart.items.length) {
      const empty = document.createElement("p");
      empty.textContent = window.themeStrings.cartEmpty || "Your cart is empty.";
      root.appendChild(empty);
      return;
    }

    cart.items.forEach((item) => root.appendChild(createCartItemElement(item)));
  }

  // The cart page rows are server-rendered. When the cart gains a line the page
  // doesn't have (e.g. "+ Add" from the recommendations), re-render the rows
  // from Liquid via the Section Rendering API instead of building them in JS.
  async function replaceCartPageItems(pageItemsRoot) {
    const form = pageItemsRoot.closest("[data-cart-page-section]");
    const sectionId = form && form.getAttribute("data-cart-page-section");
    if (!sectionId) return false;
    try {
      // No Accept: application/json here — on /cart that header makes Shopify
      // return the cart JSON instead of the rendered section.
      const response = await fetch(`/cart?sections=${encodeURIComponent(sectionId)}`);
      if (!response.ok) return false;
      const sections = await response.json();
      const html = sections[sectionId];
      if (typeof html !== "string") return false;
      const doc = new DOMParser().parseFromString(html, "text/html");
      const fresh = doc.querySelector("[data-cart-page-items]");
      if (!fresh) return false;
      pageItemsRoot.replaceChildren(...fresh.childNodes);
      return true;
    } catch (error) {
      return false;
    }
  }

  async function renderCartPage(cart) {
    const pageItemsRoot = document.querySelector("[data-cart-page-items]");
    if (!pageItemsRoot) return;

    const form = document.querySelector("[data-cart-page-form]");
    const emptyState = document.querySelector("[data-cart-page-empty]");

    if (!cart.items.length) {
      if (form) form.classList.add("d-none");
      if (emptyState) emptyState.classList.remove("d-none");
      return;
    }

    if (form) form.classList.remove("d-none");
    if (emptyState) emptyState.classList.add("d-none");

    const keys = new Set(cart.items.map((item) => item.key));
    const domKeys = new Set(
      [...pageItemsRoot.querySelectorAll("[data-cart-page-line-key]")].map((line) =>
        line.getAttribute("data-cart-page-line-key")
      )
    );
    const hasNewLine = cart.items.some((item) => !domKeys.has(item.key));
    if (hasNewLine) await replaceCartPageItems(pageItemsRoot);

    pageItemsRoot.querySelectorAll("[data-cart-page-line-key]").forEach((line) => {
      const key = line.getAttribute("data-cart-page-line-key");
      if (key && !keys.has(key)) line.remove();
    });

    cart.items.forEach((item) => {
      const lineRoot = pageItemsRoot.querySelector(`[data-cart-page-line-key="${item.key}"]`);
      if (!lineRoot) return;
      const qtyInput = lineRoot.querySelector(`[data-cart-line-key="${item.key}"]`);
      if (qtyInput) qtyInput.value = item.quantity;
      const lineTotal = lineRoot.querySelector(`[data-cart-page-line-total="${item.key}"]`);
      if (lineTotal) app.setCurrency(lineTotal, item.final_line_price);
      const unitPrice = lineRoot.querySelector(`[data-cart-page-line-unit-price="${item.key}"]`);
      if (unitPrice) app.setCurrency(unitPrice, item.final_price);
    });

    // The subtotal the Amai app is mapped to (it reads it as its base price)
    const subtotalEl = document.querySelector("[data-cart-page-subtotal]");
    if (subtotalEl) app.setCurrency(subtotalEl, cart.items_subtotal_price);

    // While a volume discount shows, the figure belongs to the previous cart:
    // keep the summary as it is until app-amai-cart-prices.js reports the
    // discount for this cart (the app needs a moment to recalculate), rather
    // than mixing the new prices with the old discount.
    if (!volumeDiscount) renderOrderSummary(cart);
  }

  // Volume discount (cents) the Amai app applies at checkout but Shopify's cart
  // doesn't know about. Reported by app-amai-cart-prices.js; 0 when none.
  let volumeDiscount = 0;

  // Order summary rows below the subtotal: plain subtotal, Discount (Shopify
  // discounts + the volume discount) and Total.
  function renderOrderSummary(cart) {
    const summary = document.querySelector("[data-cart-summary]");
    if (!summary) return;

    const volume = Math.min(Math.max(volumeDiscount, 0), cart.items_subtotal_price);

    const plainSubtotal = summary.querySelector("[data-cart-page-subtotal-plain]");
    if (plainSubtotal) app.setCurrency(plainSubtotal, cart.items_subtotal_price);

    const discount = cart.total_discount + volume;
    const discountRow = summary.querySelector("[data-cart-page-discount-row]");
    const discountAmount = summary.querySelector("[data-cart-page-discount-amount]");
    if (discountRow) discountRow.classList.toggle("d-none", !discount);
    if (discountAmount && discount) {
      app.setCurrency(discountAmount, discount, { before: "-" });
    }

    const total = summary.querySelector("[data-cart-page-total]");
    if (total) app.setCurrency(total, cart.total_price - volume);
  }

  async function refreshCart(source = "unknown") {
    const cart = await getCart();
    renderCartDrawer(cart);
    await renderCartPage(cart);
    app.emit(app.events.CART_REFRESH, { source, cart });
    return cart;
  }

  async function addToCart(form, container) {
    const formData = new FormData(form);
    // Safety floor for the minimum-quantity rule: never submit fewer than the
    // minimum from a normal product form (the stepper already enforces this in
    // the UI; this guards against DOM tampering). Exempt adds — which carry the
    // _min_qty_exempt line-item property — are left untouched.
    const isExemptAdd = formData.get("properties[_min_qty_exempt]");
    const addQty = Number(formData.get("quantity"));
    if (!isExemptAdd && !Number.isNaN(addQty) && addQty > 0 && addQty < MIN_QTY) {
      formData.set("quantity", String(MIN_QTY));
    }
    app.emit(app.events.CART_REQUEST_START, { action: "add", form });
    document.getElementById("CartDrawer")?.classList.add("cart-drawer--loading");
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" }
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.description || "Unable to add to cart");
      }

      const addedItem = await response.json();
      const cart = await refreshCart("add");
      app.emit(app.events.CART_ADD, { addedItem, cart, form, container });
      return { addedItem, cart };
    } catch (error) {
      app.emit(app.events.CART_ERROR, { action: "add", error, form, container });
      throw error;
    } finally {
      app.emit(app.events.CART_REQUEST_END, { action: "add", form, container });
      document.getElementById("CartDrawer")?.classList.remove("cart-drawer--loading");
    }
  }

  // Per-key in-flight guard: prevents concurrent change.js calls for the same
  // line item. If a change arrives while one is in flight, it is stored as
  // "pending" and fired automatically when the in-flight request settles.
  const inFlightKeys = new Set();
  const pendingChanges = new Map(); // key -> quantity

  async function changeLine(key, quantity) {
    if (inFlightKeys.has(key)) {
      pendingChanges.set(key, quantity);
      return;
    }

    inFlightKeys.add(key);
    pendingChanges.delete(key);

    document.getElementById("CartDrawer")?.classList.add("cart-drawer--loading");

    // Cart page: show a per-line loader on the line being changed/removed
    document.querySelectorAll(`[data-cart-page-line-key="${key}"]`).forEach((line) => {
      line.classList.add("is-loading");
    });

    // Disable remove buttons for this line while the request is in flight
    document.querySelectorAll(`[data-cart-remove-line="${key}"]`).forEach((btn) => {
      btn.disabled = true;
    });

    app.emit(app.events.CART_REQUEST_START, { action: "change", key, quantity });
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) throw new Error("Unable to update cart line");
      const cart = await response.json();
      renderCartDrawer(cart);
      renderCartPage(cart);
      // Signal a general cart refresh so state-tracking listeners (free shipping
      // bar, recommendations) update on quantity changes and removals too — not
      // just on add/init. The specific update/remove events still fire below.
      app.emit(app.events.CART_REFRESH, { source: "change", cart });
      if (quantity === 0) {
        app.emit(app.events.CART_REMOVE, { key, cart });
      } else {
        app.emit(app.events.CART_UPDATE, { key, quantity, cart });
      }
      return cart;
    } catch (error) {
      app.emit(app.events.CART_ERROR, { action: "change", error, key, quantity });
      throw error;
    } finally {
      app.emit(app.events.CART_REQUEST_END, { action: "change", key, quantity });
      inFlightKeys.delete(key);
      if (inFlightKeys.size === 0) {
        document.getElementById("CartDrawer")?.classList.remove("cart-drawer--loading");
      }
      document.querySelectorAll(`[data-cart-remove-line="${key}"]`).forEach((btn) => {
        btn.disabled = false;
      });
      document.querySelectorAll(`[data-cart-page-line-key="${key}"]`).forEach((line) => {
        line.classList.remove("is-loading");
      });
      // Fire any change that arrived while this request was in flight
      if (pendingChanges.has(key)) {
        const pendingQty = pendingChanges.get(key);
        pendingChanges.delete(key);
        changeLine(key, pendingQty);
      }
    }
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = window.themeStrings.addingToCart || "Adding...";
      btn.disabled = true;
      btn.classList.add("is-loading");
    } else {
      btn.textContent = btn.dataset.originalText || btn.textContent;
      btn.disabled = false;
      btn.classList.remove("is-loading");
      delete btn.dataset.originalText;
    }
  }

  function bindAjaxCartForms() {
    document.querySelectorAll("[data-product-form]").forEach((container) => {
      const form = container.closest("form");
      if (!form || form.dataset.ajaxBound === "true") return;
      form.dataset.ajaxBound = "true";
      form.addEventListener("submit", async (event) => {
        const btn = form.querySelector("[data-add-to-cart]");
        if (container.dataset.cartBehavior === "redirect") {
          event.preventDefault();
          setButtonLoading(btn, true);
          try {
            await addToCart(form, container);
            window.location.href = "/cart";
          } catch (error) {
            // Intentionally empty; errors are emitted as events.
          } finally {
            setButtonLoading(btn, false);
          }
          return;
        }
        event.preventDefault();
        setButtonLoading(btn, true);
        try {
          await addToCart(form, container);
          if (container.dataset.openCartDrawer === "true") app.openDrawer("CartDrawer");
        } catch (error) {
          // Intentionally empty; errors are emitted as events.
        } finally {
          setButtonLoading(btn, false);
        }
      });
    });
  }

  function bindDrawerLineActions() {
    // Per-key debounce map so changing item A then item B never drops either
    const qtyDebounceTimers = new Map();

    document.addEventListener("change", (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.hasAttribute("data-cart-line-key")) return;
      const key = target.getAttribute("data-cart-line-key");
      let quantity = Number(target.value);
      if (!key || Number.isNaN(quantity)) return;

      // Floor non-exempt lines at the minimum. A value of 0 still means "remove",
      // so only values between 1 and the minimum are snapped up.
      const exempt = target.dataset.minQtyExempt === "true";
      let clamped = false;
      if (!exempt && quantity > 0 && quantity < MIN_QTY) {
        quantity = MIN_QTY;
        target.value = String(MIN_QTY);
        clamped = true;
      }

      clearTimeout(qtyDebounceTimers.get(key));
      qtyDebounceTimers.set(key, setTimeout(() => {
        qtyDebounceTimers.delete(key);
        const result = changeLine(key, quantity);
        if (clamped && result && typeof result.then === "function") {
          result.then(() => showMinQtyNote(key)).catch(() => {});
        }
      }, 400));
    });

    document.addEventListener("click", (event) => {
      const target = event.target;
      // Use Element, not HTMLElement: clicks landing on the remove button's
      // inline SVG icon have an SVGElement target, which is not an HTMLElement —
      // that made icon clicks silently no-op (remove "only sometimes worked").
      if (!(target instanceof Element)) return;

      // +/- quantity stepper buttons
      const qtyBtn = target.closest("[data-qty-action]");
      if (qtyBtn) {
        const key = qtyBtn.getAttribute("data-cart-qty-key");
        const action = qtyBtn.getAttribute("data-qty-action");
        // Resolve the input from the button's own stepper first. On the cart page
        // the drawer and the page both render the same data-cart-line-key, so a
        // document-wide lookup could grab the wrong line's input.
        const input =
          qtyBtn.closest(".cart-qty-controls")?.querySelector(`[data-cart-line-key="${key}"]`) ||
          document.querySelector(`[data-cart-line-key="${key}"]`);
        if (!input) return;
        const current = Number(input.value);
        const next = action === "plus" ? current + 1 : Math.max(0, current - 1);
        input.value = next;
        // Routes through the change listener above, which applies the min-qty clamp
        input.dispatchEvent(new Event("change", { bubbles: true }));
        return;
      }

      // Remove button
      const button = target.closest("[data-cart-remove-line]");
      if (!button) return;
      const key = button.getAttribute("data-cart-remove-line");
      if (!key) return;
      changeLine(key, 0);
    });
  }

  function bindCartPageFormSubmit() {
    document.querySelectorAll("[data-cart-page-form]").forEach((form) => {
      if (form.dataset.cartPageSubmitBound === "true") return;
      form.dataset.cartPageSubmitBound = "true";
      form.addEventListener("submit", (event) => {
        const submitter = event.submitter;
        if (submitter && submitter.getAttribute("name") === "checkout") return;
        event.preventDefault();
      });
    });
  }

  function bindCartNote() {
    document.addEventListener("focusout", async (event) => {
      const target = event.target;
      if (!(target instanceof HTMLTextAreaElement) || target.id !== "CartNote") return;
      try {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ note: target.value })
        });
      } catch {
        // Silently fail — the note is still submitted with the form on checkout
      }
    });
  }

  // Public batch-add API for sections that add several lines in one request
  // (e.g. frequently-bought-together). `items` is an array of
  // { id, quantity, properties } objects passed straight to /cart/add.js.
  // Min-quantity flooring is the caller's responsibility here: exempt add-ons
  // carry properties._min_qty_exempt, normal lines pass their floored quantity.
  async function addItems(items) {
    if (!Array.isArray(items) || !items.length) return null;
    app.emit(app.events.CART_REQUEST_START, { action: "add" });
    document.getElementById("CartDrawer")?.classList.add("cart-drawer--loading");
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items })
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || "Unable to add to cart");
      }
      const addedItem = await response.json();
      const cart = await refreshCart("add");
      app.emit(app.events.CART_ADD, { addedItem, cart });
      return { addedItem, cart };
    } catch (error) {
      app.emit(app.events.CART_ERROR, { action: "add", error });
      throw error;
    } finally {
      app.emit(app.events.CART_REQUEST_END, { action: "add" });
      document.getElementById("CartDrawer")?.classList.remove("cart-drawer--loading");
    }
  }

  app.cart = app.cart || {};
  app.cart.add = addItems;
  app.cart.refresh = () => refreshCart("external");
  app.cart.setVolumeDiscount = (cents, cart) => {
    volumeDiscount = Number(cents) || 0;
    if (cart) renderOrderSummary(cart);
  };

  function init() {
    bindAjaxCartForms();
    bindDrawerLineActions();
    bindCartPageFormSubmit();
    bindCartNote();
    refreshCart("init");
    document.addEventListener("shopify:section:load", () => {
      bindAjaxCartForms();
      bindCartPageFormSubmit();
      refreshCart("section-load");
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
